import {
  DataBlockDictionaryDto,
  NumberSource,
  PatientState,
  PatientStatus,
  QueryFactory,
  SexType,
} from '@lmt/shared-types';
import { getFormattedDate } from '@lmt/unicorn-shared/app/components/patients/common';
import i18next, { TOptions } from 'i18next';
import { snakeCase } from 'lodash';
import { NS_DataBlockFields } from './useScopedTranslation';

export function localizeSexType(sex: SexType | undefined | null): string {
  return !sex ? '' : i18next.t(`translation:sex_types.${sex}`);
}

export function localizePatientState(patientState: PatientState): string {
  return i18next.t(`translation:patient_states.${patientState}`);
}

export function localizePatientStatus(patientStatus: PatientStatus): string {
  return i18next.t(`translation:patient_statuses.${patientStatus}`);
}

export function localizePermission(permission: string): string {
  return i18next.t(`translation:permissions.${snakeCase(permission)}` as any);
}

export function localizePermissionGroup(group: string): string {
  return i18next.t(`translation:roles.groups.${snakeCase(group)}` as any);
}

export function localizeNumberSource(source: NumberSource): string {
  return i18next.t(`translation:number_source.${source}`);
}

export function localizeNumberWithSource(
  number: string,
  source: NumberSource,
): string {
  if (source === NumberSource.External) {
    return `${number}-${localizeNumberSource(NumberSource.External)}`;
  } else {
    return number;
  }
}

export function localizeVisitType(
  visitTypes: QueryFactory.VisitTypeDto[],
  visitTypeId?: number | null,
): string {
  if (!visitTypeId) {
    return '';
  }
  return i18next.t(
    (visitTypes.find((visitType) => visitType.id === visitTypeId)?.value ||
      '-') as any,
  );
}

export function localizeCaseTitle(patientCase: {
  numberSource: NumberSource;
  number: string;
  id: number;
  startDate: Date;
}): string {
  return patientCase.numberSource === NumberSource.External
    ? i18next.t('translation:patients.cases.external_case_title', {
        id: patientCase.number ?? patientCase.id,
        date: getFormattedDate(patientCase.startDate),
      })
    : i18next.t('translation:patients.cases.case_title', {
        id: patientCase.number ?? patientCase.id,
        date: getFormattedDate(patientCase.startDate),
      });
}

export function localizeDictionaryColumnTitle(
  dictionary: DataBlockDictionaryDto | null | undefined,
  column: string,
) {
  const columnTranslationPrefix = dictionary?.title?.includes('_title')
    ? dictionary.title.replace('._title', '._columns.')
    : undefined;
  return columnTranslationPrefix
    ? (i18next.t((columnTranslationPrefix + column) as any, {
        defaultValue: column,
        ns: NS_DataBlockFields,
      }) as string)
    : column;
}
